export const localStorageConstants = {
  parkingAreal: {
    SearchLocalStorage: "ParkingArealSearchLocalStorage",
    SearchFilterLocalStorage: "ParkingArealSearchFilterLocalStorage",
    SearchLocationLocalStorage: "ParkingArealSearchLocationLocalStorage",
    SearchAddressLocalStorage: "ParkingArealSearchAddressLocalStorage",
  },
};
